var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.38 12.065C23.38 5.817 18.312.75 12.064.75S.75 5.817.75 12.065s5.067 11.314 11.315 11.314 11.314-5.066 11.314-11.314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.138 11.15-7.73-4.751a.7.7 0 0 0-1.065.597v9.458c0 .252.137.486.353.61a.701.701 0 0 0 .703-.013l7.73-4.712a.7.7 0 0 0 .336-.592.67.67 0 0 0-.327-.597"
  })));
};
export default SvgPlayIcon;